<script lang="ts">
  import type { ComponentProps, Snippet } from "svelte";
  import { dataField } from "../../lib/dataform/dataFormLib.svelte";
  import Fieldset from "./Fieldset.svelte";
  import { partitionNames } from "./util";

  type PropsType = Omit<ComponentProps<typeof Fieldset>, 'children' | 'error'> & {
    label: string | Snippet;
    name: string;
    required?: boolean;
  }

  let {
    legend,
    label,
    name,
    required = false,
    disabled = undefined,
    class : className,
    postfix = null,
    ...rest
  } : PropsType = $props();

  let [checkboxClass, containerClass] = $derived.by(()=>partitionNames(className, /checkbox-/))
  const field = dataField(name)
  const [get, set] = field.asBoolean
</script>
<Fieldset error={field.error as string} {legend} {disabled} class={containerClass} {postfix} {...rest}>
  <input type="hidden" name={field.name} value="false" />
  <label class="flex flex-row gap-2 items-start">
    <input class="checkbox {checkboxClass}" type="checkbox" name={field.name} bind:checked={get, set} value="true" {required} />
    {#if typeof label === "function"}
      <div class="ui-rhythm">{@render label()}</div>
    {:else}
      <span>{label}</span>
    {/if}
  </label>
</Fieldset>